import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as NegotiationActions from '../../../actions/NegotiationActions';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import './style.scss';

class DetailNegotiation extends Component {
  close = () => {
    this.props.redirectToNegoationList();
  };

  render = () => (
    <div className="detail-negotiation">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 right-column">
          <div className="title-form">
            <div className="close close-box" onClick={this.close}>
              <i className="fas fa-times-circle icon-close" />
            </div>
            <div className="title-text">
              <p className="text txt-register">Detalhe</p>
              <p className="text txt-new">Pré-venda</p>
            </div>
          </div>
          {this.props.negotiationDetail.id && (
            <div className="row detail-box">
 <div className="col-xs-12 col-md-12 col-sm-12 col-lg-12 detail-row">
 <div className="col-xs-12 col-md-12 col-sm-6 col-lg-12 text-left info">
                  <p className="text">
                    <strong>Pré-venda</strong>
                  </p>
                  <p className="text">
                    {this.props.negotiationDetail.numeroReferencia}
                  </p>
                </div>
   </div>

              <div className="col-xs-12 col-md-12 col-sm-12 col-lg-12 detail-row">



                <div className="col-xs-12 col-md-4 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Origem de Venda</strong>
                  </p>
                  <p className="text">{this.props.negotiationDetail.nome_OrigemVenda}</p>
                </div>

                <div className="col-xs-12 col-md-4 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Veiculo</strong>
                  </p>
                  <p className="text">{this.props.negotiationDetail.nome_Veiculo}</p>
                </div>

                <div className="col-xs-12 col-md-4 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Status</strong>
                  </p>
                  <p className="text">{this.props.negotiationDetail.status}</p>
                </div>



              </div>
              <div className="col-xs-12 col-md-12 col-sm-12 col-lg-12 detail-row">
                <div className="col-xs-12 col-md-6 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Cliente</strong>
                  </p>
                  <p className="text">
                    {this.props.negotiationDetail.cliente.nome}
                  </p>
                </div>
                <div className="col-xs-12 col-md-6 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Agência</strong>
                  </p>
                  <p className="text">
                    {this.props.negotiationDetail.agencias.map(a => (<p>{a.nome}</p>))}
                  </p>
                </div>
                <div className="col-xs-12 col-md-6 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Plano Comercial</strong>
                  </p>
                  {this.props.negotiationDetail.planoComercial && (
                    <p className="text">
                      {this.props.negotiationDetail.planoComercial.nome}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-xs-12 col-md-12 col-sm-12 col-lg-12 detail-row">
                <div className="col-xs-12 col-md-6 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Tipo Venda</strong>
                  </p>
                  <p className="text">
                    {this.props.negotiationDetail.tipoVenda.nome}
                  </p>
                </div>
                <div className="col-xs-12 col-md-6 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Data Início</strong>
                  </p>
                  <p className="text">
                    {moment(this.props.negotiationDetail.dataInicio).format(
                      'DD/MM/YYYY'
                    )}
                  </p>
                </div>
                <div className="col-xs-12 col-md-6 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Data Fim</strong>
                  </p>
                  <p className="text">
                    {moment(this.props.negotiationDetail.dataFim).format(
                      'DD/MM/YYYY'
                    )}
                  </p>
                </div>
              </div>
              <div className="col-xs-12 col-md-12 col-sm-12 col-lg-12 detail-row">
                <div className="col-xs-12 col-md-6 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Natureza</strong>
                  </p>
                  <p className="text">
                    {this.props.negotiationDetail.natureza.nome}
                  </p>
                </div>
                <div className="col-xs-12 col-md-6 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Tabela</strong>
                  </p>
                  <p className="text">
                    {this.props.negotiationDetail.tabelaPreco.nome}
                  </p>
                </div>
                <div className="col-xs-12 col-md-6 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Forma de Pagamento</strong>
                  </p>
                  <p className="text">
                    {this.props.negotiationDetail.tipoFaturamento.nome}
                  </p>
                </div>
              </div>
              <div className="col-xs-12 col-md-12 col-sm-12 col-lg-12 detail-row">
                <div className="col-xs-12 col-md-6 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Valor Total</strong>
                  </p>
                  <p className="text">
                    <NumberFormat
                      value={this.props.negotiationDetail.valor}
                      displayType={'text'}
                      decimalSeparator={','}
                      thousandSeparator={'.'}
                      prefix={' R$ '}
                      fixedDecimalScale
                      decimalScale={2}
                    />
                  </p>
                </div>
                <div className="col-xs-12 col-md-6 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Desconto</strong>
                  </p>
                  <p className="text">
                    <NumberFormat
                      value={this.props.negotiationDetail.percentualDesconto}
                      displayType={'text'}
                      decimalSeparator={','}
                      thousandSeparator={'.'}
                      suffix={' %'}
                      fixedDecimalScale
                      decimalScale={2}
                    />
                  </p>
                </div>
                <div className="col-xs-12 col-md-6 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Executivo Comercial</strong>
                  </p>
                  <p className="text">
                    {this.props.negotiationDetail.executivo.nomeExecutivo}
                  </p>
                </div>
              </div>
              <div className="col-xs-12 col-md-12 col-sm-12 col-lg-12 detail-row">
                <div className="col-xs-12 col-md-6 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Data Cadastro</strong>
                  </p>
                  <p className="text">
                    {moment(this.props.negotiationDetail.dataCadastro).format(
                      'DD/MM/YYYY HH:mm'
                    )}
                  </p>
                </div>
                <div className="col-xs-12 col-md-6 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Usuário Cadastro</strong>
                  </p>
                  <p className="text">
                    {this.props.negotiationDetail.nomeUsuario}
                  </p>
                </div>
                <div className="col-xs-12 col-md-6 col-sm-6 col-lg-4 text-left info">
                  <p className="text">
                    <strong>Abrangências</strong>
                  </p>
                  <p className="text">
                    {this.props.negotiationDetail.pracas
                      .map(p => `${p.nome} - ${p.sigla}`)
                      .join(', ')}
                  </p>
                </div>
              </div>
              {this.props.negotiationDetail.rateios &&
                this.props.negotiationDetail.rateios.length > 0 && (
                  <div>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Número de Referência</th>
                          <th>Tipo</th>
                          <th>Veículo</th>
                          <th>Rateio %</th>
                          <th>Rateio R$</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.negotiationDetail.rateios.map(r => (
                          <tr key={r.id}>
                            <td>{r.numeroReferencia}</td>
                            <td>
                              {r.tipo === 'OutroVeiculo'
                                ? 'Outro Veículo'
                                : r.tipo}
                            </td>
                            <td>{r.nomeVeiculo}</td>
                            <td>
                              <NumberFormat
                                value={r.porcentagem}
                                displayType={'text'}
                                decimalSeparator={','}
                                thousandSeparator={'.'}
                                suffix={' %'}
                                fixedDecimalScale
                                decimalScale={2}
                              />
                            </td>
                            <td>
                              <NumberFormat
                                value={r.valor}
                                displayType={'text'}
                                decimalSeparator={','}
                                thousandSeparator={'.'}
                                prefix={' R$ '}
                                fixedDecimalScale
                                decimalScale={2}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ negotiationReducer }) => {
  return {
    ...negotiationReducer
  };
};

export default connect(
  mapStateToProps,
  { ...NegotiationActions }
)(DetailNegotiation);
